export const createMessageError = (error) => {
  if (error.includes(`Internal Server error`)) {
    return 'Ha ocurrido un error, comuniquese con soporte si el error persiste.';
  }
  if (error.includes('Something went wrong')) {
    return 'Ha ocurrido un error, vuelva a intentarlo en unos minutos';
  }
  return error;
};
